import { useEffect, useState } from "react";
import { getRoles, getTemplates, getDoctorTemplates } from "../services/masterDataService";

export const useRoles = (domain) => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!domain) {
      setRoles([]);
      setLoading(false);
      return;
    }

    const fetchRoles = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getRoles(domain);
        setRoles(data || []);
      } catch (err) {
        console.error(`Failed to load roles`, err);
        setError(err.message || "Failed to load roles");
        setRoles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, [domain]);

  return { roles, loading, error };
};

// Keep these existing functions for other parts of the app
export const useTemplates = (domain) => {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    getTemplates(domain)
     .then((data) => {
        setTemplates(
          data.map(c => ({
            value: c.id,
            label: `${c.name} - ${c.id}`,
          }))
        );
      })
      .catch(() => {
        setTemplates([]);
      })
  }, [domain]);

  return templates;
};

export const useGetTemplatesForDoctor = (domain, doctorIDs, refreshKey = 0) => {
  const [doctorTemplates, setDoctorTemplates] = useState([]);

  useEffect(() => {
    if (!domain || !doctorIDs || doctorIDs.length === 0) {
      setDoctorTemplates([]);
      return;
    }

    let isMounted = true;

    const fetchTemplates = async () => {
      try {
        const doctorParam = Array.isArray(doctorIDs) ? doctorIDs.join(',') : doctorIDs;
        
        const data = await getDoctorTemplates(domain, doctorParam);

        if (isMounted) {
          const sorted = data.sort((a, b) => b.templateId - a.templateId);
          setDoctorTemplates(sorted.map(c => ({
            value: c.templateId,
            label: `${c.templateName} - ${c.templateId}`,
          })));
        }
      } catch (error) {
        console.error("Failed to fetch templates:", error);
        if (isMounted) setDoctorTemplates([]);
      }
    };

    fetchTemplates();

    return () => { isMounted = false; };
  }, [domain, JSON.stringify(doctorIDs), refreshKey]);
  return doctorTemplates;
};